export default __webpack_public_path__ + "static/media/es-variant.c2f89a50.svg";